import _ from 'lodash'

const status = {
    toString: number => {
        switch (number) {
        case 1:
            return 'Öppen'
        case 2:
            return 'Avslutad'
        case 3:
            return 'Planerad'
        case 4:
            return 'Pågende'
        case 5:
            return 'Avvakta'
        case 6:
            return 'Klar'
        default:
            return 'Öppen'
        }
    }
}

const sharedStatus = {
    toString: number => {
        switch (number) {
        case 0:
            return 'Nej'
        case 1:
            return 'Skickad'
        case 2:
            return 'Mottagen'
        case 3:
            return 'Läst'
        case 4:
            return 'Accepterad'
        case 5:
            return 'Nekad'
        case 6:
            return 'Klar'
        case 7:
            return 'Avslutad'
        default:
            return 'Felaktig'
        }
    }
}

const task = {
    toBody: task => {
        // Pick all necessary fields
        var body = _.pick(task, ['categories', 'tags', 'content', 'status', 'shared_status', 'user_limit', 'deadline'])

        // Set the workarea
        if (task.workarea) {
            body.workarea = task.workarea
        }

        // Map all connected users
        body.users = _.map(task.users, item => ({username: item.username}))

        return body
    },
    getCreator: task => {
        return _.find(task.users, {creator: true})
    },
    getCreatedTimeFull: task => {
        return (task.created_at === null) ? 'Aldrig' : (new Date(task.created_at)).toLocaleString('sv-SE', {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'})
    },
    getUpdatedTimeFull: task => {
        return (task.updated_at === null) ? 'Aldrig' : (new Date(task.updated_at)).toLocaleString('sv-SE', {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'})
    },
    getCreatedTime: task => {
        return (task.created_at === null) ? 'Aldrig' : (new Date(task.created_at)).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric' })
    },
    getUpdatedTime: task => {
        return (task.updated_at === null) ? 'Aldrig' : (new Date(task.updated_at)).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric' })
    },
    getSentTime: task => {
        return (task.sent_at === null) ? 'Aldrig' : (new Date(task.sent_at)).toLocaleString('sv-SE', {year: 'numeric', month: 'numeric', day: 'numeric'})
    },
    getSentTimeFull: task => {
        return (task.sent_at === null) ? 'Aldrig' : (new Date(task.sent_at)).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    formatTime: time => {
        return (time === null || time === undefined) ? 'Aldrig' : (new Date(time)).toLocaleString('sv-SE', {year: 'numeric', month: 'numeric', day: 'numeric'})
    },
    formatTimeFull: time => {
        return (time === null || time === undefined) ? 'Aldrig' : (new Date(time)).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    hasDeadlineFilter: (task, filter) => {
        if (filter === 'all') {
            return true
        }

        console.log(filter, new Date(task.deadline) > Date.now(), new Date(task.deadline) < Date.now())

        if (filter === 'due' && task.deadline !== undefined && task.deadline !== null && (new Date(task.deadline) < new Date())) {
            return true
        }

        if (filter === 'rest' && task.deadline !== undefined && task.deadline !== null && (new Date(task.deadline) > new Date())) {
            return true
        }

        return false
    },
    getLowestSharedStatus: task => {
        var status = 10

        _.each(task.users, user => {
            // Find the lowest status that is not from the creator
            if (user.shared_status < status && user.user !== task.creator && user.shared_status !== task.shared_status) {
                status = user.shared_status
            }
        })

        // Check if we didn't find any new status
        if (status === 10) {
            status = task.shared_status
        }

        return status
    },
    isReceived: (task, user, workarea) => {
        if (task.creator === user.id) {
            return false
        }

        if (task.users && task.users.length > 1) {
            // See if user is in list of receivers
            let receiver = _.find(task.users, {user: user.id})

            // Check if we have a receiver
            if (receiver) {
                return true
            }

            if (workarea !== null && workarea !== 'Ingen') {
                // Check if creator is member of the workarea
                let member = _.find(workarea.members, {id: task.creator})

                // If it's not a member we have been sent this task
                if (member === null || member === undefined) {
                    return true
                } else {
                    return false
                }
            }
        }

        return false
    },
    getCorrectStatus: (tsk, user, workarea, state) => {
        if (tsk.users && tsk.users.length > 1) {
            let self = _.find(tsk.users, {user: user.id})

            if (self !== undefined && self !== null) {
                return self.status
            }

            if (workarea !== null && workarea !== undefined) {
                let user
                _.each(workarea.members, member => {
                    if (user === null || user === undefined) {
                        user = _.find(tsk.users, {user: member.id})
                    }
                })

                if (user !== null && user !== undefined) {
                    return user.status
                }
            } else {
                if (tsk.workarea !== null && tsk.workarea !== undefined) {
                    workarea = _.find(state, {id: tsk.workarea})

                    if (workarea !== null && workarea !== undefined) {
                        let user
                        _.each(workarea.members, member => {
                            if (user === null || user === undefined) {
                                user = _.find(tsk.users, {user: member.id})
                            }
                        })

                        if (user !== null && user !== undefined) {
                            return user.status
                        } else {
                            return tsk.status
                        }
                    }
                } else {
                    return tsk.status
                }
            }
        } else {
            return tsk.status
        }
    },
    isSent: (tsk, user, workarea) => {
        if (tsk.users && tsk.users.length > 1) {
            // Check if the user is the creator of the task
            if (tsk.creator === user.id) {
                return true
            }

            if (workarea !== null && workarea !== 'Ingen') {
                // Check if a member of the workarea has sent the task
                let member = _.find(workarea.members, {id: tsk.creator})

                if (member) {
                    return true
                }
            }
        }

        return false
    },
    hasCorrectSharedStatus: (tsk, shared, user, workarea) => {
        if (shared === 'all') {
            return true
        } else if (shared === 'non' && tsk.users && tsk.users.length <= 1) {
            return true
        } else if (shared === 'sent' && task.isSent(tsk, user, workarea)) {
            return true
        } else if (shared === 'received' && task.isReceived(tsk, user, workarea)) {
            return true
        } else if (shared === 'rejected' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 5) {
            return true
        } else if (shared === 'accepted' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 4) {
            return true
        } else if (shared === 'done' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 6) {
            return true
        } else if (shared === 'read' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 3) {
            return true
        } else {
            return false
        }
    },
    isIncommingMessage: (task, user, message, workareas) => {
        if (task.workarea !== undefined && task.workarea !== null) {
            let workarea = _.find(workareas, {id: task.workarea})

            if (workarea !== undefined && workarea !== null) {
                let member = _.find(workarea.members, {username: message.user})

                if (member !== undefined && member !== null) {
                    return false
                } else {
                    return true
                }
            } else {
                if (message.user === user.username) {
                    return false
                } else {
                    return true
                }
            }
        } else if (message.user === user.username) {
            return false
        } else {
            return true
        }
    }
}

export default {
    status,
    sharedStatus,
    task
}



// WEBPACK FOOTER //
// ./src/utils/helper.js